<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center" v-if="profile">
      <v-col
              cols="12"
              md="6"
      >
        <base-material-card
                class="v-card-profile"
                :avatar="photo"
        >
          <v-card-text class="text-center">
            <h6 class="display-1 mb-1 grey--text">
              {{roles}}
            </h6>

            <h4 class="display-2 font-weight-light mb-3 black--text">
              {{profile.displayName}}
            </h4>

            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <p class="font-weight-light grey--text">
                  Телефон: {{profile.phone}}
                </p>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <p class="font-weight-light grey--text">
                  Email: {{profile.email}}
                </p>
              </v-col>
            </v-row>


            <v-btn
                    color="secondary"
                    rounded
                    class="mr-1"
                    @click="editPassword"
            >
              Сменить пароль
            </v-btn>
            <v-btn
                    color="success"
                    rounded
                    class="mr-1"
                    @click="editData"
            >
              Редактировать
            </v-btn>
            <v-btn
                    color="success"
                    rounded
                    class="mr-1"
                    @click="editPhoto"
            >
              Сменить фото
            </v-btn>
          </v-card-text>
        </base-material-card>
        <v-dialog
                v-model="dialogs.updateData"
                max-width="500px"
        >
          <v-card>
            <v-card-title>
<!--              <span class="headline">{{ formTitle }}</span>-->
            </v-card-title>

            <v-card-text>
              <v-form
                      ref="updateDataForm"
                      v-model="updateDataForm_valid"
                      lazy-validation
              >
                <v-container>
                  <v-row>
                    <v-col
                            cols="12"
                    >
                      <v-text-field
                              v-model="editedItem.displayName"
                              :label="$vuetify.lang.t('$vuetify.page.Profile.displayName')"
                              :rules="[fieldValidationRules.required(vue)]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
              >
                {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
              </v-btn>
              <v-btn
                      color="blue darken-1"
                      text
                      @click="updateData"
                      :loading="axiosLoading" :disabled="!updateDataForm_valid"
              >
                {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogs.changePassword"
                max-width="500px"
        >
          <v-card>
            <v-card-title>
              <!--              <span class="headline">{{ formTitle }}</span>-->
            </v-card-title>

            <v-card-text>
              <v-form
                      ref="changePasswordForm"
                      v-model="changePassword_valid"
                      lazy-validation
              >
                <v-container>
                  <v-row>
                      <v-col
                              cols="12"
                      >
                        <v-text-field
                                type="password"
                                v-model="editedItem.password"
                                :label="$vuetify.lang.t('$vuetify.page.Users.newPassword')"
                                :rules="[fieldValidationRules.required(vue), fieldValidationRules.newPassword(vue)]"
                        ></v-text-field>
                      </v-col>
                      <v-col
                              cols="12"
                      >
                        <v-text-field
                                type="password"
                                v-model="editedItem.confirmPassword"
                                :label="$vuetify.lang.t('$vuetify.page.Users.confirmPassword')"
                                :rules="[fieldValidationRules.required(vue), confirmPassword]"
                        ></v-text-field>
                      </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
              >
                {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
              </v-btn>
              <v-btn
                      color="blue darken-1"
                      text
                      @click="updatePassword"
                      :loading="axiosLoading" :disabled="!changePassword_valid"
              >
                {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogs.updatePhoto"
                max-width="500px"
        >
          <v-card>
            <v-card-title>
              <!--              <span class="headline">{{ formTitle }}</span>-->
            </v-card-title>

            <v-card-text>
              <v-form
                      ref="updatePhotoForm"
                      v-model="updatePhoto_valid"
                      lazy-validation
              >
                <v-container>
                  <v-row>
                      <v-col
                              cols="12"
                      >
                        <v-file-input
                                v-model="editedItem.image"
                                :label="$vuetify.lang.t('$vuetify.page.Profile.avatar')"
                                :rules="[fieldValidationRules.required(vue)]"
                        ></v-file-input>
                      </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
              >
                {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
              </v-btn>
              <v-btn
                      color="blue darken-1"
                      text
                      @click="updatePhoto"
                      :loading="axiosLoading" :disabled="!updatePhoto_valid"
              >
                {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapState} from "vuex";
  import {actionType, getterType} from "@/store/profile";
  import {mask} from 'vue-the-mask'

  export default {
    name: 'Profile',
    components: {},
    directives: {mask},
    created() {
      this.$store.dispatch(actionType.getProfile)
    },
    computed: {
      ...mapState(['barColor', 'barImage']),
      profile() {
        return this.$store.getters[getterType.profile]
      },
      formTitle() {
        return this.editedIndex === -1
                ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.crudName'))
                : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.crudName'))
      },
      roles(){
        return this.profile.roles.join(' / ')
      },
      photo(){
        if(this.profile.imagePath) {
          return `${process.env.VUE_APP_API_PATH}filestorage/profiles/${this.profile.userId}/images/${this.profile.imagePath}?v=1.0`
        }

        return this.noPhotoImg
      },
      confirmPassword(){
        return value => {
          return value === this.editedItem.password || (this.$vuetify ? this.$vuetify.lang.t('$vuetify.validation.confirmPassword') : '')
        }
      },
    },
    data() {
      return {
        noPhotoImg: require('@/assets/no-photo.png'),
        vue: this,
        updateDataForm_valid: !this.formError,
        changePassword_valid: !this.formError,
        updatePhoto_valid: !this.formError,
        dialogs: {
          updateData: false,
          changePassword: false,
          updatePhoto: false,
        },
        editedItem:{
          displayName: null,
          password: null,
          confirmPassword: null,
          image: null
        }
      }
    },
    methods: {
      editData(){
        this.editedItem.displayName = this.profile.displayName
        this.dialogs.updateData = true
      },
      editPassword(){
        this.dialogs.changePassword = true
      },
      editPhoto(){
        this.dialogs.updatePhoto = true
      },
      updateData(){
        if (this.$refs.updateDataForm.validate()) {
          this.$store.dispatch(actionType.update, {
            displayName: this.editedItem.displayName
          }).then(() => {
            this.dialogs.updateData = false
          })
        }
      },
      updatePassword(){
        if (this.$refs.changePasswordForm.validate()) {
          this.$store.dispatch(actionType.changePassword, {
            password: this.editedItem.password
          }).then(() => {
            this.dialogs.changePassword = false
          })
        }
      },
      updatePhoto(){
        if (this.$refs.updatePhotoForm.validate()) {
          this.$store.dispatch(actionType.updateImage, {
            image: this.editedItem.image
          }).then(() => {
            this.dialogs.updatePhoto = false
          })
        }
      },
      close(){
        this.dialogs.changePassword = false
        this.dialogs.updateData = false
        this.dialogs.updatePhoto = false
      }
    },
  }
</script>
